import React from "react";
import { useCategoryById } from "../../store/selectors/categorySelectors";
import { useTranslation } from "react-i18next";

interface IFormCategoryNameProps {
    categoryId: number;
}

export const FormCategoryName: React.FC<IFormCategoryNameProps> = ({ categoryId }) => {
    const { t } = useTranslation();
    const category = useCategoryById(categoryId);

    if (!category) {
        return <span>{t("Tuntematon")}</span>;
    }

    return <span>{category.name}</span>;
};
